import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateSafeDto } from '../../types/safes.types';
import { useAppMutation } from '../use-app-mutation.hook';

export const useCreate = () => {
  const { mutate: create, isPending } = useAppMutation([QueryKey.CREATE_SAFE], {
    mutationFn: ({ companyId, data }: { companyId: string; data: CreateSafeDto }) =>
      ApiService.post(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'safes'] },
        { body: data },
      ),
  });
  return { create, isPending };
};
